import React from 'react';
import Widget from '../Widget';
import WidgetTitle from '../WidgetTitle';
import { Col, Row } from 'react-bootstrap';
import BarChart from '../../Charts/BarChart';
import TableToggle from '../TableToggle';
import KeyValueData from '../../Charts/KeyValueData';
import NoData from '../NoData';
import useTableToggle from '../../Hooks/useTableToggle';

export default function NonDegreeCredentials({ institutionData }) {

    const widgetTitle = 'Non-Degree Credentials';
    const { table, handleTable } = useTableToggle();

    const data = institutionData.scorecard.certificates;

    if (data.length === 0) {
        return <NoData widgetTitle={widgetTitle} />;
    }
    data.sort((a, b) => b.awards - a.awards);

    let limit = data.length > 5 ? 5 : data.length;

    let certificates = [];
    for (let i = 0; i < limit; i++) {
        if (!data[i].awards) {
            continue;
        }
        certificates.push({
            label: data[i].name,
            value: data[i].awards,
        });
    }

    const total = data.reduce((acc, val) => acc + val.awards, 0);


    if (total === 0) {
        return <NoData widgetTitle={widgetTitle} />;
    }


    return (
        <Widget className="non-degree-credentials">
            <Row gap={5} gap-lg={0}>
                <Col xs={12} sm={9}>
                    <WidgetTitle>{widgetTitle} </WidgetTitle>
                </Col>
                <Col xs={12} sm={3}>
                    <TableToggle handleTable={handleTable} table={table} />
                </Col>
            </Row>
            <p><strong>Total number of certificates:</strong> {total}</p>
            <p>Largest certificate programs:</p>
            {!table ?
                certificates.map((certificate, i) => {
                    return (
                        <div className='my-2' key={i}>
                            <BarChart data={certificate} total={total} />
                        </div>
                    );
                })
                : <KeyValueData data={certificates} />}
        </Widget>
    );
}